import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Dialog, DialogContent, DialogActions, Button, TextField, CircularProgress } from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { FormDialogHeader, useFormDialogStyles } from "../FormDialog";

// Criar ou renomear uma lista de contatos
const ContactListDialog = ({ open, onClose, contactListId, onSaved }) => {
  const classes = useFormDialogStyles();
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName("");
    if (!contactListId) return;
    api
      .get(`/contact-lists/${contactListId}`)
      .then(({ data }) => setName(data.name || ""))
      .catch(toastError);
  }, [open, contactListId]);

  const valid = name.trim().length >= 2;

  const save = async (e) => {
    if (e) e.preventDefault();
    if (!valid || saving) return;
    setSaving(true);
    try {
      const { data } = contactListId
        ? await api.put(`/contact-lists/${contactListId}`, { name: name.trim() })
        : await api.post("/contact-lists", { name: name.trim() });
      toast.success(contactListId ? "Lista renomeada" : "Lista criada");
      if (onSaved) onSaved(data);
      onClose();
    } catch (err) {
      toastError(err);
    }
    setSaving(false);
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth classes={{ paper: classes.paper }}>
      <form onSubmit={save}>
        <FormDialogHeader
          title={contactListId ? "Renomear lista" : "Nova lista de contatos"}
          subtitle={contactListId ? null : "Depois de criar, você importa uma planilha ou adiciona contatos."}
          onClose={onClose}
          disabled={saving}
        />
        <DialogContent dividers className={classes.content}>
          <TextField
            label="Nome da lista"
            variant="outlined"
            fullWidth
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            inputProps={{ maxLength: 50 }}
            helperText="Ex.: Clientes 2026"
          />
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={onClose} disabled={saving} className={`${classes.actionButton} ${classes.cancelButton}`}>
            Cancelar
          </Button>
          <div className={classes.progressWrapper}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
              disabled={!valid || saving}
              className={classes.actionButton}
            >
              {contactListId ? "Salvar" : "Criar lista"}
            </Button>
            {saving && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ContactListDialog;
